@if(language.startsWith('de')){

<!-- ═══════════════════════ DEUTSCH ═══════════════════════ -->

<div class="top-bar">
  <button class="close-btn" (click)="closeTab()">&times; Schließen</button>
</div>

<h1><strong>Moodle-Einrichtungsanleitung</strong></h1>
<p class="subtitle">So verbinden Sie Ihre Moodle-Instanz mit Alphabees</p>

<div class="note">
  <strong>Zwei Optionen:</strong> Diese Anleitung ist in zwei Teile aufgeteilt.<br />
  <strong>Option A</strong> &mdash; Nur Kurse aus Moodle in die Wissensbasis importieren (einfach, kein Plugin nötig)<br />
  <strong>Option B</strong> &mdash; Zusätzlich Kurse von Alphabees nach Moodle erstellen und exportieren (erfordert Plugin)
</div>

<h2>Voraussetzungen</h2>
<p>
  Sie benötigen <strong>Administratorzugang</strong> zu Ihrer Moodle-Instanz.
  Alle folgenden Einstellungen befinden sich im Bereich <strong>Website-Administration</strong>.
</p>

<hr />

<!-- ──────────────── OPTION A: NUR IMPORT ──────────────── -->

<h2 class="option-header">Option A &mdash; Nur Import (Moodle &rarr; Alphabees)</h2>
<p>Folgen Sie diesen Schritten, wenn Sie nur Kurse aus Moodle in Ihre Wissensbasis synchronisieren möchten.</p>

<h3>Schritt 1: Webservices aktivieren</h3>
<ol>
  <li>Gehen Sie zu <span class="path">Website-Administration &rarr; Allgemein &rarr; Erweiterte Funktionen</span></li>
  <li>Aktivieren Sie die Option <strong>Webservices aktivieren</strong> (enablewebservices)</li>
  <li>Klicken Sie auf <strong>Änderungen speichern</strong></li>
</ol>

<h3>Schritt 2: REST-Protokoll aktivieren</h3>
<ol>
  <li>Gehen Sie zu <span class="path">Website-Administration &rarr; Server &rarr; Webservices &rarr; Protokolle verwalten</span></li>
  <li>Alternativ k&ouml;nnen Sie direkt diese URL in Ihrem Browser aufrufen (funktioniert in allen Moodle-Versionen):<br />
    <span class="path">https://your-moodle-site.com/admin/settings.php?section=webserviceprotocols</span>
  </li>
  <li>Aktivieren Sie das <strong>REST-Protokoll</strong> (Auge-Symbol klicken)</li>
</ol>

<h3>Schritt 3: Externen Service erstellen</h3>
<ol>
  <li>Gehen Sie zu <span class="path">Website-Administration &rarr; Server &rarr; Webservices &rarr; Externe Services</span></li>
  <li>Alternativ k&ouml;nnen Sie direkt diese URL in Ihrem Browser aufrufen (funktioniert in allen Moodle-Versionen):<br />
    <span class="path">https://your-moodle-site.com/admin/settings.php?section=externalservices</span>
  </li>
  <li>Klicken Sie auf <strong>Hinzufügen</strong></li>
  <li>Name: <strong>Alphabees</strong></li>
  <li>Aktivieren Sie <strong>Aktiviert</strong></li>
  <li>Optional: Aktivieren Sie <strong>Nur autorisierte Nutzer</strong></li>
  <li>Klicken Sie auf <strong>Service hinzufügen</strong></li>
</ol>

<h3>Schritt 4: Funktionen hinzufügen</h3>
<p>
  Klicken Sie beim erstellten Service auf <strong>Funktionen</strong> und fügen Sie
  folgende Funktionen hinzu:
</p>

<table class="func-table">
  <thead>
    <tr>
      <th>Funktion</th>
      <th>Beschreibung</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><code>core_webservice_get_site_info</code></td>
      <td>Verbindung validieren (wird beim Verbinden geprüft)</td>
    </tr>
    <tr>
      <td><code>core_course_get_courses</code></td>
      <td>Verfügbare Kurse auflisten</td>
    </tr>
    <tr>
      <td><code>core_course_get_courses_by_field</code></td>
      <td>Kurse gezielt abrufen und Zusatzdaten wie Teilnehmerzahl laden</td>
    </tr>
    <tr>
      <td><code>core_course_get_contents</code></td>
      <td>Kursstruktur &amp; Inhalte abrufen</td>
    </tr>
    <tr>
      <td><code>mod_page_get_pages_by_courses</code></td>
      <td>Seiteninhalt (Text) der Kursseiten abrufen</td>
    </tr>
  </tbody>
</table>

<h3>Schritt 5: Benutzer autorisieren</h3>
<ol>
  <li>Klicken Sie beim Service &quot;Alphabees&quot; auf <strong>Autorisierte Nutzer</strong></li>
  <li>Fügen Sie einen Administrator-Benutzer hinzu, der für die API-Zugriffe verwendet wird</li>
</ol>

<h3>Schritt 6: Token erstellen</h3>
<ol>
  <li>Gehen Sie zu <span class="path">Website-Administration &rarr; Server &rarr; Webservices &rarr; Token verwalten</span></li>
  <li>Alternativ: Direkter Zugang (funktioniert in allen Moodle-Versionen): <span class="path">https://ihre-moodle-seite.de/admin/webservice/tokens.php</span></li>
  <li>Klicken Sie auf <strong>Erstellen</strong></li>
  <li>Wählen Sie den <strong>Benutzer</strong> aus Schritt 5</li>
  <li>Wählen Sie den Service <strong>Alphabees</strong></li>
  <li>Klicken Sie auf <strong>Änderungen speichern</strong></li>
  <li>Kopieren Sie den angezeigten <strong>Token</strong></li>
</ol>

<h3>Schritt 7: In Alphabees verbinden</h3>
<ol>
  <li>Öffnen Sie in Alphabees unter <strong>Integrationen</strong> den Moodle-Dialog</li>
  <li>Geben Sie Ihre <strong>Moodle-URL</strong> ein (z.B. <span class="path">https://moodle.ihre-schule.de</span>)</li>
  <li>Fügen Sie den kopierten <strong>Token</strong> ein</li>
  <li>Klicken Sie auf <strong>Verbinden</strong></li>
</ol>

<div class="note">
  <strong>Fertig!</strong> Sie können jetzt Kurse aus Moodle in Ihre Wissensbasis importieren.
  Wenn Sie auch Kurse von Alphabees nach Moodle exportieren möchten, folgen Sie Option B.
</div>

<hr />

<!-- ──────────────── OPTION B: IMPORT + EXPORT ──────────────── -->

<h2 class="option-header">Option B &mdash; Import + Export (zusätzlich zu Option A)</h2>
<p>
  Folgen Sie diesen zusätzlichen Schritten, wenn Sie auch Kurse von Alphabees aus
  in Moodle erstellen und exportieren möchten. <strong>Führen Sie zuerst alle Schritte aus Option A aus.</strong>
</p>

<h3>Schritt B1: Zusätzliche Funktionen zum Service hinzufügen</h3>
<p>
  Gehen Sie zurück zu Ihrem &quot;Alphabees&quot; Service unter
  <span class="path">Website-Administration &rarr; Server &rarr; Webservices &rarr; Externe Services</span>
  und fügen Sie diese zusätzlichen Funktionen hinzu. Die letzte Funktion ist erst nach der Plugin-Installation aus Schritt B2 verfügbar:
</p>

<table class="func-table">
  <thead>
    <tr>
      <th>Funktion</th>
      <th>Beschreibung</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><code>core_course_get_categories</code></td>
      <td>Kategorien für neue Kurse auflisten</td>
    </tr>
    <tr>
      <td><code>core_course_create_courses</code></td>
      <td>Neue Kurse in Moodle erstellen</td>
    </tr>
    <tr>
      <td><code>core_course_update_courses</code></td>
      <td>Bestehende Kurse aktualisieren (Name, Beschreibung, Kategorie)</td>
    </tr>
    <tr>
      <td><code>core_course_delete_modules</code></td>
      <td>Bestehende Module vor erneutem Export löschen</td>
    </tr>
    <tr>
      <td><code>core_update_inplace_editable</code></td>
      <td>Abschnittsnamen setzen (Fallback)</td>
    </tr>
    <tr>
      <td><code>enrol_manual_enrol_users</code></td>
      <td>Benutzer einschreiben, damit Kurse im Dashboard erscheinen</td>
    </tr>
    <tr>
      <td><code>local_wsmanagesections_update_sections</code></td>
      <td>Abschnittsnamen und generierte Inhalte als HTML in Abschnittszusammenfassungen schreiben (Plugin aus Schritt B2 erforderlich)</td>
    </tr>
  </tbody>
</table>

<h3>Schritt B2: Plugin für Kursinhalte installieren</h3>
<div class="note">
  <strong>Wichtig:</strong> Ohne dieses Plugin werden Kurse mit korrekten Abschnittsnamen erstellt, aber <strong>ohne Inhalte in den Abschnitten</strong>.
  Das Plugin ist erforderlich, damit Kursinhalte als HTML in den Abschnittszusammenfassungen erscheinen.
</div>
<a
  class="plugin-link"
  href="https://moodle.org/plugins/local_wsmanagesections"
  target="_blank"
  rel="noopener"
>
  &#8599; Plugin herunterladen: local_wsmanagesections
</a>
<ol>
  <li>Laden Sie das Plugin als ZIP-Datei herunter</li>
  <li>Gehen Sie zu <span class="path">Website-Administration &rarr; Plugins &rarr; Plugin installieren</span></li>
  <li>Laden Sie die ZIP-Datei hoch und folgen Sie den Installationsanweisungen</li>
  <li>Alternativ: Entpacken Sie das Plugin nach <span class="path">/local/wsmanagesections/</span> auf Ihrem Server</li>
  <li>Fügen Sie <code>local_wsmanagesections_update_sections</code> zu Ihrem &quot;Alphabees&quot; Service hinzu</li>
</ol>

<div class="note">
  <strong>Fertig!</strong> Ihr Service sollte jetzt insgesamt <strong>12 Funktionen</strong> haben (5 aus Option A + 6 Standardfunktionen aus Option B + 1 Plugin-Funktion).
  Sie können nun Kurse in beide Richtungen synchronisieren.
</div>

<hr />

<h2>Fehlerbehebung</h2>

<div class="troubleshoot-item">
  <strong>&quot;Ungültiger Token&quot; oder &quot;Zugriff verweigert&quot;</strong>
  <p>Prüfen Sie, ob der Token korrekt kopiert wurde und ob der zugeordnete Benutzer dem Service &quot;Alphabees&quot; zugewiesen ist.</p>
</div>

<div class="troubleshoot-item">
  <strong>&quot;Funktion nicht verfügbar&quot;</strong>
  <p>Stellen Sie sicher, dass alle benötigten Funktionen dem Service hinzugefügt wurden (5 für Import, 12 für Import + Export inkl. Plugin).</p>
</div>

<div class="troubleshoot-item">
  <strong>Exportierte Kurse erscheinen nicht im Moodle-Dashboard</strong>
  <p>Stellen Sie sicher, dass <code>enrol_manual_enrol_users</code> zum Service hinzugefügt wurde. Ohne diese Funktion werden Kurse erstellt, erscheinen aber nicht unter &quot;Meine Kurse&quot;. Sie finden sie unter <span class="path">Website-Administration &rarr; Kurse &rarr; Kurse verwalten</span>.</p>
</div>

<div class="troubleshoot-item">
  <strong>Kurse können importiert, aber nicht exportiert werden</strong>
  <p>Für den Export werden die zusätzlichen Funktionen aus Option B benötigt. Prüfen Sie, ob alle Funktionen aktiviert sind.</p>
</div>

<div class="troubleshoot-item">
  <strong>Exportierte Kurse haben keine Inhalte in den Abschnitten</strong>
  <p>Installieren Sie das optionale Plugin <code>local_wsmanagesections</code> (Schritt B2) und fügen Sie <code>local_wsmanagesections_update_sections</code> zum Service hinzu, um Kursinhalte als HTML in den Abschnitten darzustellen.</p>
</div>

} @else {

<!-- ═══════════════════════ ENGLISH ═══════════════════════ -->

<div class="top-bar">
  <button class="close-btn" (click)="closeTab()">&times; Close</button>
</div>

<h1><strong>Moodle Setup Guide</strong></h1>
<p class="subtitle">How to connect your Moodle instance to Alphabees</p>

<div class="note">
  <strong>Two options:</strong> This guide is split into two parts.<br />
  <strong>Option A</strong> &mdash; Import courses from Moodle into your knowledge base only (simple, no plugin needed)<br />
  <strong>Option B</strong> &mdash; Additionally create and export courses from Alphabees to Moodle (requires plugin)
</div>

<h2>Prerequisites</h2>
<p>
  You need <strong>administrator access</strong> to your Moodle instance.
  All settings below are found in the <strong>Site Administration</strong> area.
</p>

<hr />

<!-- ──────────────── OPTION A: IMPORT ONLY ──────────────── -->

<h2 class="option-header">Option A &mdash; Import Only (Moodle &rarr; Alphabees)</h2>
<p>Follow these steps if you only want to sync courses from Moodle into your knowledge base.</p>

<h3>Step 1: Enable Web Services</h3>
<ol>
  <li>Go to <span class="path">Site Administration &rarr; General &rarr; Advanced features</span></li>
  <li>Enable <strong>Enable web services</strong> (enablewebservices)</li>
  <li>Click <strong>Save changes</strong></li>
</ol>

<h3>Step 2: Enable REST Protocol</h3>
<ol>
  <li>Go to <span class="path">Site Administration &rarr; Server &rarr; Web services &rarr; Manage protocols</span></li>
  <li>Alternatively, you can navigate directly to this URL (works in all Moodle versions):<br />
    <span class="path">https://your-moodle-site.com/admin/settings.php?section=webserviceprotocols</span>
  </li>
  <li>Enable the <strong>REST protocol</strong> (click the eye icon)</li>
</ol>

<h3>Step 3: Create an External Service</h3>
<ol>
  <li>Go to <span class="path">Site Administration &rarr; Server &rarr; Web services &rarr; External services</span></li>
  <li>Alternatively, you can navigate directly to this URL (works in all Moodle versions):<br />
    <span class="path">https://your-moodle-site.com/admin/settings.php?section=externalservices</span>
  </li>
  <li>Click <strong>Add</strong></li>
  <li>Name: <strong>Alphabees</strong></li>
  <li>Check <strong>Enabled</strong></li>
  <li>Optional: Check <strong>Authorised users only</strong></li>
  <li>Click <strong>Add service</strong></li>
</ol>

<h3>Step 4: Add Required Functions</h3>
<p>
  Click <strong>Functions</strong> on the created service and add
  the following functions:
</p>

<table class="func-table">
  <thead>
    <tr>
      <th>Function</th>
      <th>Description</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><code>core_webservice_get_site_info</code></td>
      <td>Validate connection (checked when connecting)</td>
    </tr>
    <tr>
      <td><code>core_course_get_courses</code></td>
      <td>List available courses</td>
    </tr>
    <tr>
      <td><code>core_course_get_courses_by_field</code></td>
      <td>Fetch courses by field and load additional data such as participant count</td>
    </tr>
    <tr>
      <td><code>core_course_get_contents</code></td>
      <td>Fetch course structure &amp; content</td>
    </tr>
    <tr>
      <td><code>mod_page_get_pages_by_courses</code></td>
      <td>Fetch full text content of page modules</td>
    </tr>
  </tbody>
</table>

<h3>Step 5: Authorise a User</h3>
<ol>
  <li>Click <strong>Authorised users</strong> on the &quot;Alphabees&quot; service</li>
  <li>Add an administrator user who will be used for API access</li>
</ol>

<h3>Step 6: Create a Token</h3>
<ol>
  <li>Go to <span class="path">Site Administration &rarr; Server &rarr; Web services &rarr; Manage tokens</span></li>
  <li>Alternatively: Direct access (works in all Moodle versions): <span class="path">https://your-moodle-site.com/admin/webservice/tokens.php</span></li>
  <li>Click <strong>Create token</strong></li>
  <li>Select the <strong>user</strong> from Step 5</li>
  <li>Select the <strong>Alphabees</strong> service</li>
  <li>Click <strong>Save changes</strong></li>
  <li>Copy the displayed <strong>token</strong></li>
</ol>

<h3>Step 7: Connect in Alphabees</h3>
<ol>
  <li>In Alphabees, open the Moodle dialog under <strong>Integrations</strong></li>
  <li>Enter your <strong>Moodle URL</strong> (e.g. <span class="path">https://moodle.your-school.com</span>)</li>
  <li>Paste the copied <strong>token</strong></li>
  <li>Click <strong>Connect</strong></li>
</ol>

<div class="note">
  <strong>Done!</strong> You can now import courses from Moodle into your knowledge base.
  If you also want to export courses from Alphabees to Moodle, follow Option B.
</div>

<hr />

<!-- ──────────────── OPTION B: IMPORT + EXPORT ──────────────── -->

<h2 class="option-header">Option B &mdash; Import + Export (in addition to Option A)</h2>
<p>
  Follow these additional steps if you also want to create and export courses
  from Alphabees into Moodle. <strong>Complete all steps from Option A first.</strong>
</p>

<h3>Step B1: Add Additional Functions to the Service</h3>
<p>
  Go back to your &quot;Alphabees&quot; service under
  <span class="path">Site Administration &rarr; Server &rarr; Web services &rarr; External services</span>
  and add these additional functions. The last function is only available after installing the plugin from Step B2:
</p>

<table class="func-table">
  <thead>
    <tr>
      <th>Function</th>
      <th>Description</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><code>core_course_get_categories</code></td>
      <td>List categories for new courses</td>
    </tr>
    <tr>
      <td><code>core_course_create_courses</code></td>
      <td>Create new courses in Moodle</td>
    </tr>
    <tr>
      <td><code>core_course_update_courses</code></td>
      <td>Update existing course properties (name, summary, category)</td>
    </tr>
    <tr>
      <td><code>core_course_delete_modules</code></td>
      <td>Clear existing modules before re-exporting updated content</td>
    </tr>
    <tr>
      <td><code>core_update_inplace_editable</code></td>
      <td>Set section names (fallback)</td>
    </tr>
    <tr>
      <td><code>enrol_manual_enrol_users</code></td>
      <td>Enrol user so exported courses appear in the dashboard</td>
    </tr>
    <tr>
      <td><code>local_wsmanagesections_update_sections</code></td>
      <td>Write section names and generated content as HTML into section summaries (requires the plugin from Step B2)</td>
    </tr>
  </tbody>
</table>

<h3>Step B2: Install Plugin for Course Content</h3>
<div class="note">
  <strong>Important:</strong> Without this plugin, courses are created with correct section names but <strong>no content in sections</strong>.
  The plugin is required for course content to appear as HTML in section summaries.
</div>
<a
  class="plugin-link"
  href="https://moodle.org/plugins/local_wsmanagesections"
  target="_blank"
  rel="noopener"
>
  &#8599; Download plugin: local_wsmanagesections
</a>
<ol>
  <li>Download the plugin as a ZIP file</li>
  <li>Go to <span class="path">Site Administration &rarr; Plugins &rarr; Install plugins</span></li>
  <li>Upload the ZIP file and follow the installation instructions</li>
  <li>Alternatively: Extract the plugin to <span class="path">/local/wsmanagesections/</span> on your server</li>
  <li>Add <code>local_wsmanagesections_update_sections</code> to your &quot;Alphabees&quot; service</li>
</ol>

<div class="note">
  <strong>Done!</strong> Your service should now have a total of <strong>12 functions</strong> (5 from Option A + 6 standard functions from Option B + 1 plugin function).
  You can now sync courses in both directions.
</div>

<hr />

<h2>Troubleshooting</h2>

<div class="troubleshoot-item">
  <strong>&quot;Invalid token&quot; or &quot;Access denied&quot;</strong>
  <p>Verify that the token was copied correctly and that the assigned user is authorised for the &quot;Alphabees&quot; service.</p>
</div>

<div class="troubleshoot-item">
  <strong>&quot;Function not available&quot;</strong>
  <p>Make sure all required functions have been added to the service (5 for import, 12 for import + export incl. plugin).</p>
</div>

<div class="troubleshoot-item">
  <strong>Exported courses don't appear in the Moodle dashboard</strong>
  <p>Make sure <code>enrol_manual_enrol_users</code> has been added to the service. Without it, courses are created but don't show up under &quot;My courses&quot;. You can find them under <span class="path">Site Administration &rarr; Courses &rarr; Manage courses</span>.</p>
</div>

<div class="troubleshoot-item">
  <strong>Courses can be imported but not exported</strong>
  <p>Exporting requires the additional functions from Option B. Check that all functions are enabled.</p>
</div>

<div class="troubleshoot-item">
  <strong>Exported courses have no content in sections</strong>
  <p>Install the optional <code>local_wsmanagesections</code> plugin (Step B2) and add <code>local_wsmanagesections_update_sections</code> to the service to render course content as HTML in section summaries.</p>
</div>

}
